import cx from 'classnames'
import { ReactNode, useId } from 'react'

interface CheckboxProps {
  checked: boolean
  setChecked: (checked: boolean) => void
  children?: ReactNode
  className?: string
}

const Checkbox = ({
  checked,
  setChecked,
  children,
  className,
}: CheckboxProps) => {
  const id = useId()

  return (
    <div className={className}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(event) => {
          setChecked(event.target.checked)
        }}
        className="absolute w-[1px] h-[1px] p-0 m-[-1px] overflow-hidden whitespace-nowrap border-none opacity-0"
      />

      <label
        htmlFor={id}
        className={cx(
          'inline-flex items-center gap-x-3',
          'relative top-auto left-auto mx-auto p-0',
          'transform-none cursor-pointer',
        )}
      >
        <div
          className={cx(
            'p-1.5 border border-black rounded',
            'pointer-events-none transition-colors duration-150',
            'text-white',
            {
              'bg-blue': checked,
            },
          )}
        >
          <svg
            viewBox="0 0 15 11"
            className={cx(
              'block flex-none w-[12px] h-[12px]',
              'transition-colors duration-150',
              {
                'delay-150': !checked,
                'delay-0': checked,
              },
            )}
          >
            <path
              d="M1.5 5.9285L5.21429 9.64279L13.5714 1.28564"
              fill="none"
              strokeWidth="1.5"
              strokeLinecap="square"
              className={cx(
                'stroke-current text-current',
                'transition-all duration-150 delay-0',
                'stroke-dasharray-120',
                {
                  'stroke-dashoffset-120': !checked,
                  'stroke-dashoffset-0 delay-150': checked,
                },
              )}
            />
          </svg>
        </div>
        {children}
      </label>
    </div>
  )
}

export default Checkbox
